import {useCallback, useMemo} from "react";
import {
	DateField,
	SelectField
} from "~/components/Forms";
import {strToTime} from "~/utils";
import {useUtilities} from "~/hooks";

const statusOptions = [
	{ value: '', label: 'Tất cả trạng thái' },
	{ value: 'pending', label: 'Chờ xác định' },
	{ value: 'resolved', label: 'Đã xác định' },
];

function PendingReceiptSearchBar({onChange}) {

	const {utilities} = useUtilities();

	const bankAccountOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả tài khoản' }, ...Object.entries(utilities.bankAccounts || {}).map(([key, value]) => ({
			value: key,
			label: value.title,
		}))];
	}, [utilities.bankAccounts]);

	const handleTimeChange = useCallback((value) => {
		value = strToTime(value);
		if(onChange) onChange('time', value);
	}, [onChange]);

	const handleStatusChange = useCallback((value) => {
		if(onChange) onChange('status', value);
	}, [onChange]);

	const handleBankChange = useCallback((value) => {
		if(onChange) onChange('bankAccount', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<DateField name="time" picker="month" onChange={handleTimeChange}/>
					<SelectField placeholder="Trạng thái" options={statusOptions} onChange={(value) => handleStatusChange(value)} />
					<SelectField placeholder="Tài khoản ngân hàng" options={bankAccountOptions} onChange={(value) => handleBankChange(value)} />
				</form>
			</div>
		</div>
	)
}

export default PendingReceiptSearchBar;
